// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.multiTableSortMenuWrapper__WcaHS {
  display: inline-flex;
}

.multiSortIcon__w2pko {
  cursor: pointer;
}
.multiSortIcon__w2pko path {
  fill: var(--tables-title-icon);
}

.multiTableSortMenu__TcuP1 {
  background: var(--tables-secondary-row-sub-title-surface) !important;
  width: 190px !important;
  padding: 0px !important;
  opacity: 1 !important;
  border-radius: 4px !important;
  text-align: left !important;
  box-shadow: var(--modal-box-shadow);
  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));
}

.tooltipContainer__zPoZM {
  text-align: left;
  padding: 18px 15px;
}

.textContainer__WVVkH {
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  text-align: left;
  color: var(--tables-secondary-row-sub-title-text);
  text-transform: uppercase;
  display: flex;
  justify-content: space-between;
  padding-bottom: 15px;
}

.radioButtonsContainer__UprKP {
  display: inline-flex;
  flex-direction: column;
  gap: 10px;
}

.radioButtonContainer__lUtT1 {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.hideResetButton__E5cWO {
  display: none;
}`, "",{"version":3,"sources":["webpack://./../src/components/common/MultiTableSortMenu/style.module.scss"],"names":[],"mappings":"AA4EA;EACE,oBAAA;AA3EF;;AA8EA;EACE,eAAA;AA3EF;AA6EE;EACE,8BAAA;AA3EJ;;AA+EA;EAEE,oEAAA;EACA,uBAAA;EACA,uBAAA;EACA,qBAAA;EACA,6BAAA;EACA,2BAAA;EACA,mCAAA;EACA,mDAAA;AA7EF;;AAgFA;EACE,gBAAA;EACA,kBAAA;AA7EF;;AAgFA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iDAAA;EACA,yBAAA;EACA,aAAA;EACA,8BAAA;EACA,oBAAA;AA7EF;;AAgFA;EACE,oBAAA;EACA,sBAAA;EACA,SAAA;AA7EF;;AAgFA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AA7EF;;AAgFA;EACE,aAAA;AA7EF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n@import 'src/assets/variables.scss';\n\n.multiTableSortMenuWrapper {\n  display: inline-flex;\n}\n\n.multiSortIcon {\n  cursor: pointer;\n\n  path {\n    fill: var(--tables-title-icon);\n  }\n}\n\n.multiTableSortMenu {\n  // importants below to overwrite react-tooltip styles\n  background: var(--tables-secondary-row-sub-title-surface) !important;\n  width: 190px !important;\n  padding: 0px !important;\n  opacity: 1 !important;\n  border-radius: 4px !important;\n  text-align: left !important;\n  box-shadow: var(--modal-box-shadow);\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n}\n\n.tooltipContainer {\n  text-align: left;\n  padding: 18px 15px;\n}\n\n.textContainer {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 14px;\n  text-align: left;\n  color: var(--tables-secondary-row-sub-title-text);\n  text-transform: uppercase;\n  display: flex;\n  justify-content: space-between;\n  padding-bottom: 15px;\n}\n\n.radioButtonsContainer {\n  display: inline-flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.radioButtonContainer {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n}\n\n.hideResetButton {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"multiTableSortMenuWrapper": `multiTableSortMenuWrapper__WcaHS`,
	"multiSortIcon": `multiSortIcon__w2pko`,
	"multiTableSortMenu": `multiTableSortMenu__TcuP1`,
	"tooltipContainer": `tooltipContainer__zPoZM`,
	"textContainer": `textContainer__WVVkH`,
	"radioButtonsContainer": `radioButtonsContainer__UprKP`,
	"radioButtonContainer": `radioButtonContainer__lUtT1`,
	"hideResetButton": `hideResetButton__E5cWO`
};
module.exports = ___CSS_LOADER_EXPORT___;
